define('ContactUsForm.View'
,	[
		'tavanoteam_contactusform_contactusform.tpl'
	,	'Utils'
	,	'Backbone'
	,	'Backbone.FormView'	
	,	'Backbone.CompositeView'
	,	'jQuery'
	,	'TavanoTeam.ContactUsForm.Model'
	,	'ContactUsForm.Confirmation.View'
	,	'SC.Configuration'
	,	'underscore'
	,	'GlobalViews.Message.View'
	]
,	function (
		tavanoteam_contactusform_contactusform_tpl
	,	Utils
	,	Backbone
	,	BackboneFormView
	,	BackboneCompositeView
	,	jQuery
	,	ContactUsFormModel
	,	ContactUsFormConfirmationView
	,	Configuration
	,	_
	,	GlobalViewsMessageView
	)
{
	'use strict';

	return Backbone.View.extend({

	template: tavanoteam_contactusform_contactusform_tpl,
	
	initialize: function (options) {
		BackboneCompositeView.add(this);
		this.model = new ContactUsFormModel();
		var self = this;

		this.model.fetch({
			data: { id: 204 }
		})
		.done(function(response) {
			self.render();
		});

		//Get Components
		this.application = options.application;
		var environment = this.application.getComponent('Environment');

		//Get ReCaptcha Configuration
		this.siteKey = environment.getConfig('TTCaptchaKeysV3.siteKey');
		this.javascriptAPIUrl = environment.getConfig('TTCaptchaKeysV3.javascriptAPIUrl');
		this.enableLogs = environment.getConfig('TTCaptchaKeysV3.enableLogs');
		this.enableRecaptcha = this.siteKey && this.javascriptAPIUrl;

		//Load ReCaptcha
		window.grecaptcha = _.bind(this.render, this);
		this.loadRecaptchaScript(this.siteKey, this.javascriptAPIUrl);
		this.captchaPromise = jQuery.getScript(this.javascriptAPIUrl);

		BackboneFormView.add(this);  
		this.model.on('save', jQuery.proxy(this, 'manageResponse'));

	},
	
	bindings: {
			'[name="firstname"]': 'firstname'
		,	'[name="lastname"]': 'lastname'
		,	'[name="email"]': 'email'
		,	'[name="help"]': 'help'
		,	'[name="question"]': 'question'
		,	'[name="phone"]': 'phone'	
		,	'[name="industry"]': 'industry'	
		,	'[name="company"]': 'company'	
	},

	events: {
		'submit form': 'validateForm'
	},
	
	defineValues: function defineValues(list, isSubject){
		var ret = [];

		if(isSubject){
			_.each(list,function(element, i){
				var elementInfo = {
					isActive: false,
					label: element
				}
				ret.push(elementInfo);
			})
		}else{
			_.each(list,function(element, i){
				var elementInfo = {
					internalId: element.valueid,
					isActive: false,
					label: element.value
				}
				ret.push(elementInfo);
			})
		}
		return ret;
	},
	manageResponse : function showSuccess(model) {
		
		var targetEl = '#grecaptcha-error-message';

		if (model.get("status") == 500){

			//Show Recaptcha Error Message
			var messageView = new GlobalViewsMessageView({
				errorCode: 'ERR_RECAPTCHA_INVALID',
				message: model.get("message"),
				type: 'error',
				closable: true
			});
			
			this.$(targetEl).show();
			this.$(targetEl).html(messageView.render().$el);

		} else {

			//Show Success Message
			this.$(targetEl).hide();
			this.showSuccess();
		}
	},

	showSuccess : function showSuccess() {
		var layout = this.application.getLayout();
		var contactUsFormConfirmationView = new ContactUsFormConfirmationView({});
		layout.showInModal(contactUsFormConfirmationView,{});
	},
	render: function(){
		
		Backbone.View.prototype.render.apply(this, arguments);
	
	},
	
	submitForm: function (e) {
		
		BackboneFormView.saveForm.apply(this, arguments);

	},

	validateForm: function(e){

		var self = this;

		if(this.enableRecaptcha && this.captchaPromise.state() === 'resolved'){

			try {

				e.preventDefault();

				var gRecaptcha = grecaptcha || window.grecaptcha
				,   promise = jQuery.Deferred()
				,   grecaptchaRes = {};

				gRecaptcha.ready(function()
				{
					gRecaptcha.execute(self.siteKey, {action:'contactUsForm'})
					.then(function(token)
					{
	
						if(self.enableLogs) {
							console.log("gRecaptcha Token", token);
						}

						//Set Token
						self.model.set('token', token);

						//Submit Form
						self.submitForm(e);
						
					})
				});
			} catch (err) {
				console.log('Error rendering recaptcha: ', err);
			}
		} else {
			
			//Submit Form
			this.submitForm(e);

		}

	},

	loadRecaptchaScript: function loadRecaptchaScript(siteKey, javascriptAPIUrl){
        
		var script = document.createElement('script');

		script.type = "text/javascript";
		script.src = javascriptAPIUrl + siteKey;
		script.defer = true;

		jQuery('head').append(script);
        
	},

	getContext: function getContext()
	{
		var subjectQuestion = Configuration.subjectQuestion ? this.defineValues(Configuration.subjectQuestion, true) : "";
		var industry = this.model.attributes.industry ? this.defineValues(this.model.attributes.industry) : "";
		return {
			industrySelectValues: industry,
			subjectQuestionSelectValues: subjectQuestion
		};
	},
	});
});
